import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    address: {},
    products: [],
    user_id: 0
};

const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        updateOrder:(state,action)=>{
            return {...state,...action.payload}
        }
    }
});

export const orderActions = orderSlice.actions;

export default orderSlice;